export default "__VITE_ASSET__CHWuxmvU__"